import { Button, Icon } from "@zapier/design-system";
import { Tooltip } from "@zapier/design-system-beta";
import { useAtomValue, useSetAtom } from "jotai";
import {
  togglesAtomResettable,
  refreshAssetSetter,
} from "@zapier/canvas-state";

export default function RefreshAssetButton({
  isLoading,
}: {
  isLoading: boolean;
}) {
  const toggles = useAtomValue(togglesAtomResettable);
  const handleRefreshAsset = useSetAtom(refreshAssetSetter);

  if (!toggles.aiCopilotCobuild) {
    return null;
  }

  return (
    <Tooltip
      key="refresh-asset-button-tooltip"
      content="Refresh preview"
      placement="top"
      offset="small"
    >
      <Tooltip.FocusableTrigger>
        <Button
          variant="tertiary"
          size="small"
          iconPosition="start"
          onPress={handleRefreshAsset}
          isDisabled={isLoading}
        >
          <Icon name="arrowRefresh" />
        </Button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}
